/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useMemo, useState } from 'react';
import { CommonActions, useLinkProps } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import {
  Linking,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import store from '@/store';
import {
  setSavedFilter as dispatchSavedFilter,
  resetFilter as resetFilterNonParams,
} from '@/store/filter';
import {
  resetFilter,
  paramsReseted,
  resetAllScopedParams,
} from '@/store/params';
import { useSelector, useDispatch } from 'react-redux';
import Colors from '@/global/colors';
import { firstLetter } from '@/global/helpers';
import {
  isWeb,
  isMobileWeb,
  isNative,
  isAndroid,
  isWebPlatform,
  isAndroidEdgeToEdge,
} from '@global/screens';
import B2bRouting from '@/global/web-routing';
import Image from '@components/global/Image';
import VersionApp from '@components/global/VersionApp';
import { showAlert } from '@/store/global';
import { MENUS, SETTING_MENUS, SETTINGS } from '@/constants/menus';
import { NET_DOMAIN } from '@/constants';

const photoWidth = 50;
const defaultSizeIcon = { width: isWeb ? 18 : 22, height: 18 };
const defaultStyleIcon = {
  ...(!isNative
    ? {
        ...defaultSizeIcon,
        filter: isMobileWeb ? 'unset' : 'brightness(0) invert(1)',
      }
    : {}),
  marginLeft: 10,
  marginRight: 15,
};

const activeBackground = isWeb ? { backgroundColor: Colors.blue3 } : {};
const activeColor = {
  color: isWeb ? '#FFFFFF' : '#0028E4',
};
const normalColor = {
  color: isWeb ? '#FFFFFF' : '#81858B',
};

const openExternalLink = (url) => {
  if (!url) {
    return;
  }
  if (isWebPlatform) {
    window.open(url, '_blank');
  } else {
    Linking.openURL(url);
  }
};

const DrawerButton = React.memo(
  (btnProps) => {
    const { convertParams, testID } = btnProps;
    const item = btnProps?.item ? btnProps.item : {};

    if (isWeb && (item?.screen || item?.stack_screen)) {
      const [isHovered, setIsHovered] = useState(false);

      let to = `/`;
      let params = item?.is_form
        ? { id: '', name: '', titleScreen: '' }
        : item?.params || {};
      if (item?.stack_screen) {
        // eslint-disable-next-line no-global-assign
        screen = item?.stack_screen;
      }
      if (item?.customParams && Object.keys(item.customParams).length) {
        params = item.customParams;
      }
      const routing = B2bRouting[item?.screen];
      if (routing?.path) {
        to = routing?.path;
        if (item?.stack_screen && routing?.screens[item.stack_screen]) {
          to = `${to}${routing?.screens[item.stack_screen]}`;
        }
      }
      if (params && Object.keys(params).length) {
        const queryString = Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join('&');
        to = `${to}?${queryString}`;
      }

      const action = CommonActions.navigate(item.screen, convertParams(item));
      const { onPress, ...props } = useLinkProps({ to, action });

      return (
        <View
          testID={testID}
          onClick={(e) => {
            store.dispatch(resetFilter());
            store.dispatch(dispatchSavedFilter({ reset: true }));
            store.dispatch(resetFilterNonParams());
            store.dispatch(paramsReseted());
            store.dispatch(resetAllScopedParams());
            onPress(e);
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={[
            btnProps.style ? btnProps.style : {},
            { transitionDuration: '500ms', opacity: isHovered ? 0.8 : 1 },
          ]}
          {...props}>
          {btnProps.children}
        </View>
      );
    } else {
      return <TouchableOpacity testID={testID} {...btnProps} />;
    }
  },
  (prev, next) => prev == next,
);

const SubItem = React.memo(
  ({ item, testID }) => {
    return !item.setting_child ? (
      <DrawerLogo item={item} testID={testID} />
    ) : (
      <View style={{ width: 30 }}></View>
    );
  },
  (prev, next) => prev == next,
);

const DrawerChild = React.memo(
  (props) => {
    const { item, goToMenu, convertParams } = props;

    const generateTestID = (name) => {
      return `sidebar-submenu-${name.toLowerCase().replace(/\s+/g, '-')}`;
    };

    return item.is_open_sub_menu && item.childs && item.childs.length
      ? item.childs.map((sub_item, sub_key) => {
          const subMenuTestID = generateTestID(sub_item.name);
          return (
            <DrawerButton
              {...props}
              activeOpacity={0.6}
              key={`drawer-sub-menu-${sub_key}`}
              testID={subMenuTestID}
              style={[
                styles.menus,
                styles.subMenus,
                sub_item.is_active_sub && isWeb ? activeBackground : {},
              ]}
              item={sub_item}
              convertParams={convertParams}
              onPress={() => goToMenu(sub_item, false)}>
              <SubItem item={sub_item} testID={`${subMenuTestID}-icon`} />
              <Text
                testID={`${subMenuTestID}-title`}
                style={[
                  styles.menu_item,
                  sub_item.is_active_sub ? activeColor : normalColor,
                ]}>
                {sub_item.name}
              </Text>
            </DrawerButton>
          );
        })
      : null;
  },
  (prev, next) => prev == next,
);

const DrawerLogo = React.memo(
  ({ item, testID }) => {
    return (
      <Image
        testID={testID}
        width={defaultSizeIcon.width}
        height={defaultSizeIcon.height}
        style={defaultStyleIcon}
        svg={true}
        source={item.is_active && !isWeb ? item.icon_active : item.icon}
      />
    );
  },
  (prev, next) => prev == next,
);

const DrawerMenu = (props) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const menuPermission = useSelector((state) => state.auth.menuPermission);
  const [activeMenu, setActiveMenu] = useState({ name: '' });
  const [isSetting, setIsSetting] = useState(false);
  const insets = useSafeAreaInsets();

  let active_menu = null;

  const goToProfile = () => {
    props.navigation.dispatch(
      CommonActions.setParams({
        id: '',
        name: '',
        titleScreen: '',
        branchId: '',
        branchName: '',
      }),
    );
    props.navigation.navigate('ProfileNavigator', {
      screen: 'ProfileScreen',
      params: {
        id: '',
        name: '',
        titleScreen: '',
        branchId: '',
        branchName: '',
      },
    });
  };

  // show confirm popup before leave page
  const confirmLeave = (item) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Discard',
        description: 'Unsaved data will be deleted. Do you want to proceed?',
        onCallback: (val) => {
          goToMenu(item);
        },
      }),
    );
  };

  // convert route parameter before redirect to other page
  const convertParams = (item) => {
    return {
      screen: item.stack_screen,
      params: item.is_form
        ? {
            id: '',
            name: '',
            titleScreen: '',
            firstAdded: '',
          }
        : item.customParams && Object.keys(item.customParams).length
        ? item.customParams
        : {},
    };
  };

  // action to handle change the route
  const goToMenu = (item, confirm = true) => {
    if (item?.external_url) {
      openExternalLink(item.external_url);
      return;
    }
    store.dispatch(resetFilter());
    store.dispatch(dispatchSavedFilter({ reset: true }));
    store.dispatch(dispatchSavedFilter({}));
    store.dispatch(resetFilterNonParams());
    store.dispatch(paramsReseted());
    const hasScreen = Boolean(item.stack_screen || item.screen);
    if (
      item?.confirm_leave &&
      !confirm &&
      hasScreen &&
      item.name === active_menu.name
    ) {
      confirmLeave(item);
      return;
    }
    active_menu = item;
    setActiveMenu(item);
    if (hasScreen) {
      if (item.stack_screen) {
        try {
          props.navigation.replace(item.screen, convertParams(item));
        } catch (error) {
          props.navigation.navigate(item.screen, convertParams(item));
        }
      } else {
        props.navigation.navigate(item.screen);
      }
    }
  };

  // check active navigator name
  const checkRouteActive = (props) => {
    return (
      props &&
      props.state &&
      props.state.index &&
      props.state.index > -1 &&
      props.state.routes &&
      props.state.routes.length &&
      props.state.routes[props.state.index] &&
      props.state.routes[props.state.index].name
    );
  };

  // check permission menu
  const checkRoles = (menu) => {
    const userRole = userData?.role?.code || '';
    if (menu.hiddenForRoles?.length && menu.hiddenForRoles.includes(userRole)) {
      return false;
    }
    if (menu.permissions?.length) {
      return Boolean(
        menu.permissions.findIndex((p) => menuPermission.indexOf(p) > -1) > -1,
      );
    }
    return true;
  };

  // convert menu lists and show to sidebar
  const getDrawerMenu = (props) => {
    const checkPermission = (menus) => {
      return menus.reduce((newData, data, index) => {
        const is_active = isActiveMenu(props, data);
        const is_open_sub_menu = isOpenSubMenu(props, data);
        if (is_active) {
          active_menu = data;
        }
        if (data.childs?.length) {
          if (checkRoles(data)) {
            newData.push({
              ...data,
              is_active,
              is_open_sub_menu,
              childs: data.childs
                .filter((x) => checkRoles(x))
                .map((x) => {
                  const is_active_sub = isActiveSubMenu(props, x);
                  if (is_active_sub) {
                    active_menu = x;
                  }
                  return {
                    ...x,
                    is_active_sub,
                  };
                }),
            });
          }
        } else {
          if (checkRoles(data)) {
            newData.push({ ...data, is_active, is_open_sub_menu });
          }
        }
        return newData;
      }, []);
    };
    const settingArray = SETTING_MENUS.map((item) => item.screen);
    if (
      isWeb &&
      checkRouteActive(props) &&
      settingArray.indexOf(checkRouteActive(props)) > -1
    ) {
      if (!isSetting) {
        setIsSetting(true);
      }
      return checkPermission(SETTINGS);
    }
    if (isSetting) {
      setIsSetting(false);
    }

    const resultMenu = checkPermission(MENUS);

    const is3PL = userData?.role?.code === '3pl'; // handle for local development
    const isExternalWeb =
      isWebPlatform && NET_DOMAIN.includes(window.location.hostname);

    // if 3PL or external web, only show Goods Received Note (GRN dashboard + list)
    if (is3PL || isExternalWeb) {
      const grnMenus = MENUS.reduce((acc, m) => {
        if (m.name === 'Goods Received Note') {
          acc.push(m);
        } else if (m.name === 'Business Tracker' && m.childs?.length) {
          const grnChilds = m.childs.filter(
            (c) => c.name === 'Goods Received Note',
          );
          if (grnChilds.length) {
            acc.push({ ...m, childs: grnChilds });
          }
        }
        return acc;
      }, []);
      return checkPermission(grnMenus);
    }

    if (
      userData?.role?.code == 'salesman' &&
      userData?.salesman_type === 'spreading'
    ) {
      const filteredResultMenu = resultMenu.map((menu) => {
        if (menu.name === 'Transaction' && menu.childs) {
          menu.childs = menu.childs.filter(
            (child) =>
              child.name !== 'Return Order' &&
              child.name !== 'Add Sales Order' &&
              child.name !== 'Add Return Order',
          );
        }

        return menu;
      });

      return filteredResultMenu;
    }

    return resultMenu;
  };

  // check active menu navigator
  const isActiveMenu = (props, item) => {
    return (
      activeMenu.name == item.name ||
      item.screen == checkRouteActive(props) ||
      (!activeMenu.name &&
        item.name == 'Dashboard' &&
        (checkRouteActive(props) == 'HomeNavigator' ||
          checkRouteActive(props) === 0)) ||
      (item.childs && item.childs.length
        ? item.childs.findIndex(
            (c) =>
              c.name == activeMenu.name || c.screen == checkRouteActive(props),
          ) > -1
        : false)
    );
  };

  // check active sub menu
  const isActiveSubMenu = (props, item) => {
    return (
      activeMenu.name == item.name || item.screen == checkRouteActive(props)
    );
  };

  // check sub menu has been opened
  const isOpenSubMenu = (props, item) => {
    return (
      activeMenu.name == item.name ||
      item.name == 'Setting' ||
      (item.childs && item.childs.length
        ? item.childs.findIndex(
            (c) =>
              c.name == activeMenu.name || c.screen == checkRouteActive(props),
          ) > -1
        : false)
    );
  };

  const ProfileSection = useMemo(() => {
    return !isWeb ? (
      <TouchableOpacity
        testID="sidebar-profile-wrapper"
        activeOpacity={0.9}
        onPress={() => goToProfile()}
        style={[
          styles.profile,
          isAndroidEdgeToEdge && { paddingTop: insets.top },
        ]}>
        <View style={styles.photoContainer}>
          <Image
            testID="sidebar-profile-image"
            source={userData.image}
            isPhoto={true}
            style={styles.photo}
            width={photoWidth}
            height={photoWidth}
            compressWidth={photoWidth}
          />
        </View>
        <View style={styles.profileText}>
          <View>
            <Text
              testID="sidebar-profile-name"
              style={styles.profileName}
              numberOfLines={1}>
              {userData.name ? userData.name : '-'}
            </Text>
          </View>
          <View>
            <Text
              testID="sidebar-profile-role"
              style={styles.profilePosition}
              numberOfLines={1}>
              {userData.role && userData.role.name
                ? firstLetter(userData.role.name)
                : '-'}
            </Text>
          </View>
        </View>
      </TouchableOpacity>
    ) : (
      false
    );
  }, [userData]);

  return (
    <SafeAreaView style={{ flex: 1 }}>
      {/* Start Profile Container */}
      {ProfileSection}
      {/* End Profile Container */}
      {/* Start Sidebar Menu Container */}
      <ScrollView
        {...props}
        // RN's SafeAreaView is iOS-only, so nothing consumes the bottom inset on
        // Android and the last menu item runs under the nav bar.
        contentContainerStyle={[
          props.contentContainerStyle,
          { paddingBottom: isAndroid ? insets.bottom : 0 },
        ]}>
        {isWeb && (
          <View style={styles.webLogoContainer}>
            <Image
              testID="sidebar-web-logo"
              width={120}
              height={46}
              style={styles.webLogoImage}
              resizeMode="contain"
              source={require('@assets/img/logo/nina_2025.svg')}
              svg
            />
          </View>
        )}
        {!isWeb && <VersionApp />}
        {getDrawerMenu(props).map((item, key) => {
          const menuTestID = `sidebar-menu-${item.name
            .toLowerCase()
            .replace(/\s+/g, '-')}`;
          return (
            <View key={`drawer-menu-${key}`} testID={`${menuTestID}-wrapper`}>
              <DrawerButton
                {...props}
                activeOpacity={0.6}
                testID={menuTestID}
                style={[
                  styles.menus,
                  item.is_active && item.name != 'Setting' && isWeb
                    ? activeBackground
                    : {},
                ]}
                item={item}
                convertParams={convertParams}
                onPress={() => goToMenu(item, false)}>
                <DrawerLogo item={item} testID={`${menuTestID}-icon`} />
                <Text
                  testID={`${menuTestID}-text`}
                  style={[
                    styles.menu_item,
                    item.is_active ? activeColor : normalColor,
                  ]}>
                  {item.name}
                </Text>
              </DrawerButton>
              <DrawerChild
                {...props}
                item={item}
                convertParams={convertParams}
                goToMenu={goToMenu}
              />
            </View>
          );
        })}
      </ScrollView>
      {/* End Sidebar Menu Container */}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  profile: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 20,
    paddingHorizontal: 15,
    ...(isAndroid
      ? { marginVertical: 20 }
      : {
          marginTop: 20,
          marginBottom: isMobileWeb ? 20 : 10,
          zIndex: 1,
        }),
  },
  // eslint-disable-next-line react-native/no-color-literals
  photoContainer: {
    borderColor: '#fff',
    borderWidth: 2,
    borderRadius: 30,
    backgroundColor: Colors.blue1,
    justifyContent: 'center',
    marginRight: 12,
    overflow: 'hidden',
    width: photoWidth,
    height: photoWidth,
  },
  photo: {
    width: photoWidth,
    height: photoWidth,
  },
  profileText: {
    textAlign: 'left',
  },
  profileName: {
    maxWidth: 180,
    fontSize: 14,
    fontFamily: 'figtree-regular',
    marginBottom: 5,
  },
  // eslint-disable-next-line react-native/no-color-literals
  profilePosition: {
    maxWidth: 180,
    fontSize: 11,
    fontFamily: 'figtree-regular',
    color: '#8f8f8f',
  },
  webLogoContainer: {
    width: 180,
    backgroundColor: Colors.white,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 20,
    borderTopRightRadius: 40,
    borderBottomRightRadius: 200,
  },
  webLogoImage: {
    width: 110,
    height: 46,
  },
  menus: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
  },
  subMenus: {
    paddingLeft: 15,
  },
  menu_item: {
    fontSize: 12,
    fontFamily: 'figtree-regular',
  },
});

export default DrawerMenu;
